import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeFullscreenGallery } from '../../actions/fullscreenGallery';
import { FullscreenGallery } from '../../components/FullscreenGallery';
import { selectConstructionProgress } from '../../selectors/constructionProgress';
import { selectDateSlideIndex, selectIsOpenGallery, selectSlideIndex } from '../../selectors/fullscreenGallery';
import { selectNewbuildingName } from '../../selectors/newbuilding';

export const FullscreenGalleryContainer: React.VFC = () => {
  const isOpen = useSelector(selectIsOpenGallery);
  const slideIndex = useSelector(selectSlideIndex);
  const dateSlideIndex = useSelector(selectDateSlideIndex);
  const constructionProgress = useSelector(selectConstructionProgress);
  const newbuildingName = useSelector(selectNewbuildingName);
  const dispatch = useDispatch();

  const handleCloseGallery = React.useCallback(() => {
    dispatch(closeFullscreenGallery());
  }, [dispatch]);

  if (!isOpen) {
    return null;
  }

  return (
    <FullscreenGallery
      initialSlideIndex={slideIndex}
      initialStageIndex={dateSlideIndex}
      onClose={handleCloseGallery}
      stages={constructionProgress}
      title={`ЖК «${newbuildingName}»`}
      open
    />
  );
};
